const SEO = [
	{
		page: "home",
		description:
			"Zhongkang Guo is a software engineer at Robinhood with expertise in algorithms and system design. Holds Master's from University of Toronto and Bachelor's from Tsinghua University. Passionate about building scalable technology and exploring different cultures through language learning.",
		keywords: ["Zhongkang Guo", "Software Engineer", "Robinhood", "University of Toronto", "Tsinghua University", "Backend Development", "System Design"],
	},

	{
		page: "about",
		description:
			"I am a backend developer with expertise in Node.js. I have experience in building scalable, secure and reliable web applications using various frameworks and technologies.",
		keywords: ["Zhongkang", "Zhongkang Guo", "Robinhood"],
	},

	{
		page: "life",
		description:
			"Learn more about my personal life, interests, and podcast where I share stories and insights.",
		keywords: ["Zhongkang", "Zhongkang Guo", "Life", "Podcast", "Personal"],
	},

	{
		page: "work",
		description:
			"My professional journey as a software engineer, including experience at Robinhood and other companies. Learn about my career progression and the impact I've made in the tech industry.",
		keywords: ["Zhongkang", "Zhongkang Guo", "Work Experience", "Software Engineer", "Robinhood", "Career"],
	},

	{
		page: "education",
		description:
			"My educational background including Master's degree from University of Toronto and Bachelor's degree from Tsinghua University.",
		keywords: ["Education", "University of Toronto", "Tsinghua University", "Computer Science"],
	},
];

export default SEO;
